export class FranchiseShort {
    id?: number;
    name?: string;
    logo?: string;
    min_rate?: number;
    max_rate?: number;
    avg_rate?: number;

    static fromJson(fields: any): FranchiseShort {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
